import axiosHandler from "../../Intersepter/axiosInstance";


// Login function
export const userLogin = async (data) => {
  try {
    const response = await axiosHandler.post('/auth/login', data);
    return response.data;
  } catch (error) {
    throw  error.response?.data?.error
  }
};


export const setPassword = async (payload) => {
    try {
        const response = await axiosHandler.post(`/auth/reset-password`, payload);
        return response.data;
    } catch (error) {
        throw error.response?.data?.error ;
    }
};

export const userSignup = async (data) => {
  try {
    const response = await axiosHandler.post('/auth/sign-up', data);
    return response.data;
  } catch (error) {
    throw  error.response?.data?.message
  }
};
